<template lang="pug">
.approvers-container
  .approvers-container__col
    TargetVerificators(
      :target="this.target"
      :target_id="this.target_id"
    )
  .approvers-container__col
    TargetApprover(
      :target="this.target"
      :target_id="this.target_id"
    )
</template>

<script>
import TargetVerificators from "@/views/Approvers/verificators.vue";
import TargetApprover from "@/views/Approvers/approver.vue";

export default {
  props: ["target", "target_id"],

  components: {
    TargetApprover,
    TargetVerificators,
  },
};
</script>

<style lang="scss" scoped>
.approvers-container {
  display: flex;
  gap: 1rem;

  &__col {
    width: 50%;
    flex-shrink: 1;
  }
}
</style>
